import {useAtom} from 'jotai'

import {
  categoriesAtom,
  detailAtom,
  familysAtom,
  listAtom,
  listFilterAtom,
  visibilitysAtom,
} from '../store'

export const useProduct = () => {
  const [list, listSet] = useAtom(listAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)
  const [detail, detailSet] = useAtom(detailAtom)

  const [visibility, visibilitySet] = useAtom(visibilitysAtom)
  const [categories, categoriesSet] = useAtom(categoriesAtom)
  const [family, familySet] = useAtom(familysAtom)

  return {
    list,
    listSet,
    listFilter,
    listFilterSet,
    detail,
    detailSet,
    categories,
    categoriesSet,
    family,
    familySet,
    visibility,
    visibilitySet,
  }
}
